module.exports = __webpack_public_path__ + "assets/d2f7983b983d34c21ae314d3d4eb9b14.png";